import React, { useContext, useState } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Confirm, Container } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import SiteVodafoneStore from '../../../app/stores/sitevodafoneStore';
import { Link } from 'react-router-dom';

const EmployeeSiteVodafoneList: React.FC = () => {
  const sitevodafoneStore = useContext(SiteVodafoneStore);
  const {sitevodafonenamesByDate: sitevodafonenamesByDate,  
    deleteSiteVodafone: deleteSiteVodafone, submitting, target} = sitevodafoneStore;

  return (

      <Table celled unstackable>
    <Table.Header>
      <Table.Row>
      <Table.HeaderCell>Site ID</Table.HeaderCell>
      <Table.HeaderCell>Site Name</Table.HeaderCell>
        <Table.HeaderCell>Direct Access</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {sitevodafonenamesByDate.map(sitevodafone => (
     <Table.Row key={sitevodafone.id}> 
    <Table.Cell><Link to={`/employeeportal/sitevodafone/${sitevodafone.id}`} style={{ color: "blue" }}>
      {sitevodafone.siteID_c}</Link></Table.Cell> 
        <Table.Cell>{sitevodafone.siteName}</Table.Cell> 
        <Table.Cell>{sitevodafone.direct_Access}</Table.Cell> 
        <Table.Cell><a href={`https://maps.google.com/?q=${sitevodafone.address}`} target="_Blank">
          {sitevodafone.address}</a></Table.Cell> 
      </Table.Row> 
    ))}
    </Table.Body>
  </Table>

  );
};

export default observer(EmployeeSiteVodafoneList);
